import type { JSX } from "react";

import { Tooltip as BaseTooltip } from "@base-ui/react/tooltip";

import type { TooltipProps } from "./Tooltip.types";

export function Tooltip<Payload = unknown>({
  ...props
}: TooltipProps<Payload>): JSX.Element {
  return <BaseTooltip.Root data-slot="tooltip" {...props} />;
}
